export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/constant.js
// module id = v7aS
// module chunks = 0